<div mat-dialog-title>
  <h2>{{ 'authorization-history.title' | translate }}</h2>
</div>
<mat-progress-bar *ngIf="inProgress"  mode="indeterminate"></mat-progress-bar>

<mat-dialog-content>
  <div *ngIf="tz" class="tz">
    {{ 'common.history-tz-text' | translate }} <b>{{ tz }}</b>.
  </div>
  <div *ngFor="let day of histories$ | async; let i = index" class="day-block">
    <div>
      <div class="day">
        {{ day.date.calendar(null, calendarFormats) }}
      </div>
      <div class="date">
        {{ day.date | momentDate:tz }}
      </div>
    </div>
    <div class="records">
      <div *ngFor="let record of day.records" class="record">
        <div class="time">
          {{ record.createdAt | momentTime:tz:'LT' }}
        </div>
        <div class="data">
          <div>
            {{ getEventTypeText(record) }}<b *ngIf="record.clinician" [matTooltip]="record.clinician.email">{{ getByText(record) }}</b>
          </div>
          <div *ngFor="let change of getChanges(record)">
            <b>{{ change.key | titlecase }}</b><span [innerHTML]="change.value"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
